export const conversationHistory = "/:app_group_id/conversational/conversations/:history_type";
export const conversationHistoryDetail = "/:app_group_id/conversational/conversations/:history_type/:session_id";
